module.exports = __webpack_public_path__ + "static/bltm-980c84ffebab3419a507a3d5974cf68b.jpeg";